import type { PayPeriodsResponse } from '@libs/data-access/queries'
import { queryClientOptions } from '@libs/data-access/queries'
import { useQuery } from '@tanstack/react-query'

import type { UseAppQueryOptions } from '../../../types'
import type { FetchPayPeriodsOptions } from '../payPeriod.api'
import { fetchPayPeriods } from '../payPeriod.api'
import { payPeriodsQueryKeys } from '../payPeriod.queryKeys'

export const useFetchPayPeriods = (
  request?: FetchPayPeriodsOptions,
  queryOptions?: UseAppQueryOptions<PayPeriodsResponse>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: payPeriodsQueryKeys.all(request?.queryParams),
    queryFn: () => fetchPayPeriods(request),
    staleTime: queryClientOptions.time.DYNAMIC
  })
}
